<template>
  <CDialog
    @click="close"
    @outer-click="close"
    :show="show"
    :no-header="true"
    :custom-class="'max-w-[421px]'"
  >
    <div class="flex-y-center p-5 flex-col justify-center text-center">
      <div
        class="mb-5 flex items-center justify-center w-[72px] h-[72px] p-4 bg-yellow-100 rounded-full"
      >
        <span class="icon-dollar text-5xl text-yellow" />
      </div>

      <!-- Display Wallet Balances -->
      <div class="max-w-[381px] text-center mb-4">
        <h5 class="mb-2 text-dark-100 font-semibold text-xl">
          {{ $t("wallet") }}
        </h5>
        <div class="text-dark text-center mb-4">
          <span class="text-sm leading-110 text-dark-200">
            {{ $t("min_user_wallet_balance") }}: <strong>10 USDT</strong>
          </span>
        </div>
        <div class="text-center mt-2">
          <span :class="userWalletBalance > 0 ? 'text-green' : 'text-red'">
            {{ $t("balans_wallet") }}:
            <strong>{{ formattedBalance }} USDT</strong>
          </span>
        </div>

        <!-- Progress Indicator -->
        <div class="w-full bg-gray-200 rounded-full h-2.5 mt-4">
          <div
            class="h-2.5 rounded-full"
            :style="{ width: progress + '%', backgroundColor: progressColor }"
          ></div>
        </div>
      </div>

      <!-- Cancel Button -->
      <div class="w-full flex-y-center mt-4 gap-2">
        <CButton
          :text="$t('cancel')"
          class="w-full"
          variant="info"
          @click="close"
        />
        <RouterLink to="/wallet" class="w-full">
          <CButton
            :text="$t('top_up_wallet')"
            class="w-full"
            variant="primary"
            @click="close"
          />
        </RouterLink>
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CButton from "@/components/Common/CButton.vue";
import { computed } from "vue";
import { useAuthStore } from "@/modules/Auth/stores";

interface Props {
  show: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
}>();

const close = () => {
  emit("close");
};

const store = useAuthStore();

const userWalletBalance = computed(() => store.user.balance);
// Formatted balance display for negative values
const formattedBalance = computed(() =>
  userWalletBalance.value < 0
    ? `-${Math.abs(userWalletBalance.value)}`
    : userWalletBalance.value,
);

// Progress calculation
const progress = computed(() => (userWalletBalance.value / 10) * 100);
const progressColor = computed(() =>
  userWalletBalance.value > 0 ? "#4caf50" : "#E52E30",
);
</script>

<style scoped></style>
